import React from 'react';
import PartnersLink from "../../Partners/components/PopupManagePartners/PartnersLink/PartnersLink";

export function CopyPartnersLinkColumnFormatter(cellContent) {

  return <PartnersLink link={cellContent}/>
}
